import { useEffect, useState } from "react";

import useService from "../../../../hooks/useService";
import { getHiddenDocumentTypeKeys } from "../utils/documentTypeOptions";

const useHiddenDocumentTypeKeys = () => {
  const fieldOptionRepository = useService("repositories/field-option-repository");
  const [hiddenKeys, setHiddenKeys] = useState(null);

  useEffect(() => {
    let isActive = true;

    const fetchHiddenKeys = async () => {
      try {
        const fieldOptions = await fieldOptionRepository.query({
          content_type: "document",
          field_name: "document_type",
          limit: 100,
        });

        if (isActive) {
          setHiddenKeys(getHiddenDocumentTypeKeys(fieldOptions));
        }
      } catch {
        if (isActive) {
          setHiddenKeys([]);
        }
      }
    };

    fetchHiddenKeys();

    return () => {
      isActive = false;
    };
  }, [fieldOptionRepository]);

  return hiddenKeys;
};

export default useHiddenDocumentTypeKeys;
